/* eslint import/prefer-default-export:0 */

import logStats from 'app/common/lib/logStats';

function unescapeAndParse(data) {
  return JSON.parse(
    data
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&'),
  );
}

export function unpackStartArgs() {
  /* eslint-disable pinterest/no-referencing-p-properties */
  if (document !== undefined) {
    if (P.startArgs === undefined) {
      const init1 = document.getElementById('jsInit1');
      if (init1) {
        P.startArgs = unescapeAndParse(init1.textContent);

        init1.innerHTML = '';
      }
    }
  }

  const context = P.startArgs.context || {};
  Pc.experiments = Pc.experiments || {};
  const triggerable = {
    ...Pc.experiments.triggerable,
    ...context.triggerable_experiments,
  };
  const active = {
    ...Pc.experiments.active,
    ...context.active_experiments,
  };
  P.startArgs.context.triggerable_experiments = triggerable;
  P.startArgs.context.active_experiments = active;
  Pc.experiments.triggerable = triggerable;
  Pc.experiments.active = active;

  const hasActive = Object.keys(context.active_experiments).length > 0;
  const hasTriggerable = Object.keys(context.triggerable_experiments).length > 0;
  logStats.increment('denzel.unpackStartArgs.experiments_merged', 0.01, {
    has_active: hasActive,
    has_triggerable: hasTriggerable,
  });
  /* eslint-enable pinterest/no-referencing-p-properties */
}
